module.exports = __webpack_public_path__ + "img/companyIntro5.b02785fa.png";